import { render, staticRenderFns } from "./ExtraCostData.vue?vue&type=template&id=290c57e8&scoped=true"
import script from "./ExtraCostData.vue?vue&type=script&lang=js"
export * from "./ExtraCostData.vue?vue&type=script&lang=js"
import style0 from "./ExtraCostData.vue?vue&type=style&index=0&id=290c57e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290c57e8",
  null
  
)

export default component.exports